import React from "react";
import { Row, Col, Typography, Button } from "antd";
import PageNotFoundSVG from "svgs/PageNotFound";
import { useHistory } from "react-router-dom";

function PageNotFound() {
  const { Title, Text } = Typography;
  const history = useHistory();
  const onClickHomePage = () => {
    history.goBack();
  };

  return (
    <div className="k-page-not-found">
      <Row gutter={[48, 32]} justify="center" align="middle" style={{ width: "100%", maxWidth: 960 }}>
        <Col xs={24} md={12} style={{ display: "flex", justifyContent: "center" }}>
          <Row gutter={[16, 16]} justify="center">
            <Col span={24}>
              <Title level={1}>
                Page not found
              </Title>
            </Col>
            <Col span={24}>
              <Text>
                The page you are looking for has been removed or doesn&apos;t exist.
              </Text>
            </Col>
            <Col span={24}>
              <Button type="primary" onClick={onClickHomePage}>
                Go back
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={24} md={12} style={{ display: "flex", justifyContent: "center" }}>
          <PageNotFoundSVG />
        </Col>
      </Row>
    </div>
  );
}

export default PageNotFound;
